import { useContext, useEffect } from "react"
import { Navigate, Outlet } from "react-router"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"
import { WideLayout } from "source/Layout"
import { useOrganizationSetting } from "source/registrations/hooks/useOrganization"
import { PublishedPageGuard } from "source/shared/guards/PublishedPageGuard"

export default function RegistrationsLayout() {
  return (
    <PublishedPageGuard identifier="registrations">
      <RegistrationsLayoutContents />
    </PublishedPageGuard>
  )
}

function RegistrationsLayoutContents() {
  const { paths } = useContext(ServerRenderedProps)
  const canUseChurchCenterWeb = useOrganizationSetting("churchCenterWeb")
  const canUseChurchCenterWebRegistrations = useOrganizationSetting(
    "churchCenterWebRegistrations",
  )

  useEffect(() => {
    if (!canUseChurchCenterWeb) {
      window.location = paths.missing_organization
    }
  }, [canUseChurchCenterWeb, paths])

  if (!canUseChurchCenterWebRegistrations) {
    return <Navigate to="/home" replace />
  }

  return (
    <WideLayout>
      <Outlet />
    </WideLayout>
  )
}
